import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './AvatarCustomization.css';

export default function AvatarStaging() {
  const navigate = useNavigate();
  const location = useLocation();
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('token');
  const email = localStorage.getItem('username');
  const [isSaving, setIsSaving] = useState(true);

  const avatarUrl = location.state?.avatarUrl;

  useEffect(() => {
    if (!avatarUrl) {
      console.error("❌ No avatar URL found in location state.");
      navigate('/avatar-customize');
      return;
    }

    const saveAvatar = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/avatar/save`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ email, avatarUrl }),
        });

        const result = await response.text();
        console.log("✅ Backend result:", result);

        if (response.ok) {
          localStorage.removeItem("signupProgress");
          localStorage.setItem("avatarSaved", "true");
          localStorage.setItem("isLoggedIn", "true");

          setTimeout(() => {
            navigate('/profile');
          }, 800);
        } else {
          console.error("❌ Avatar save failed:", result);
          setIsSaving(false);
        }
      } catch (err) {
        console.error("❌ Error saving avatar:", err);
        setIsSaving(false);
      }
    };

    saveAvatar();
  }, [avatarUrl, navigate, API_BASE_URL, token, email]);

  return (
    <div className="AvatarCustomization">
      <div className="space-bg"></div>
      {isSaving ? (
        <div className="spinner">Saving your avatar...</div>
      ) : (
        <div className="error-message">
          Something went wrong. <br />
          <button onClick={() => navigate('/avatar-customize')}>
            Try Again
          </button>
        </div>
      )}
    </div>
  );
}
